import { z } from 'zod';

export const uuidSchema = z.uuid();
export type Uuid = z.infer<typeof uuidSchema>;

/** Email normalisé : trim puis minuscules. La base indexe lower(email), le serveur normalise toujours avant. */
export const emailSchema = z.string().trim().toLowerCase().pipe(z.email().max(254));
